import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api, qk, unwrap } from '../api/client';
import { useAuth } from '../app/auth';

// Bell = approvals waiting for me + unread alerts (GET /notifications/summary); click opens My approvals.
// It is polled, refreshed when the tab comes back to the front, and invalidated by every approval decision
// (api/wf.ts afterDecision) and by "Mark all read" (api/rpt.ts) — a number that only changed once a minute was
// read as the notice not arriving at all.
export const NOTIFICATION_POLL_MS = 30_000;

export function NotificationBell() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const user = useAuth((s) => s.user);
  const summary = useQuery({
    queryKey: qk.one('core', 'notifications', 'summary'),
    queryFn: () => unwrap(api.GET('/api/v1/notifications/summary')),
    enabled: user !== null,
    refetchInterval: NOTIFICATION_POLL_MS,
    refetchOnWindowFocus: true,
    staleTime: 0,
  });
  const count = (summary.data?.pendingApprovals ?? 0) + (summary.data?.unreadAlerts ?? 0);
  return (
    <button type="button" className="bell" title={t('topbar.notifications')} aria-label={t('topbar.notificationsCount', { count })} onClick={() => void nav('/wf/inbox')}>
      🔔{count > 0 && <i aria-hidden="true">{count}</i>}
    </button>
  );
}
